import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VSkeletonLoader,{attrs:{"type":"paragraph"}}),_c(VSkeletonLoader,{attrs:{"type":"text"}}),_vm._l((3),function(index){return _c(VSkeletonLoader,{key:index,attrs:{"type":"list-item-avatar-two-line"}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }